import React from 'react'
import { ActionButton, Button, ButtonModel } from '@notino/react-styleguide'

// styles
import * as SC from './EmptyStyles'

// hooks
import useMessages from '../../hooks/useMessages'

// assets
import EmptyStateIcon from '../../assets/icons/EmptyStateIcon'

type Props = {
	title?: React.ReactNode
	label?: React.ReactNode
	icon?: React.ReactNode
	minHeight?: string
	maxWidth?: string
	padding?: string
	button?: {
		href?: string
		label: string
		onClick?: (e: React.SyntheticEvent<HTMLElement>) => void
		isLoading?: boolean
	}
	className?: string
	role?: React.AriaRole
}

const Empty = (props: Props) => {
	const { label, title, icon = <EmptyStateIcon />, minHeight = '300px', maxWidth = '400px', padding, button, className, role } = props
	const { messages } = useMessages()

	return (
		<SC.EmptyWrapper $minHeight={minHeight} className={className} $padding={padding} role={role}>
			{icon && <SC.EmptyIconWrapper>{icon}</SC.EmptyIconWrapper>}
			<SC.EmptyTitle $maxWidth={maxWidth}>{title || messages['Unfortunately, no data was found']}</SC.EmptyTitle>
			{label && <SC.EmptyLabel $maxWidth={maxWidth}>{label}</SC.EmptyLabel>}
			{button && (
				<SC.ButtonWrapper>
					{button.href ? (
						<Button type={'button'} href={button.href} buttonStyle={ButtonModel.Styles.primary} onClick={button.onClick}>
							{button.label}
						</Button>
					) : (
						<ActionButton
							type={'button'}
							buttonStyle={ButtonModel.Styles.primary}
							onClick={button.onClick}
							isLoading={button.isLoading}
							disabled={button.isLoading}
						>
							{button.label}
						</ActionButton>
					)}
				</SC.ButtonWrapper>
			)}
		</SC.EmptyWrapper>
	)
}

export default Empty
